/* eslint-disable */
let self;
let datalayer_items;
let datalayer_event;
let request_origin;
let ajax_action;
let item_id;
let item_name;
let item_category;
let item_category2;
let item_category3;
let item_category4;
let item_price;
let item_quantity;
let item_brand;
let transaction_id;
let cart_total_value;
let ecommerce;
let user_email;
let user_id;

export class DataLayer_cart {
  constructor(datalayer_attr) { // Receive part of the attributes to create the datalayer
    self = this;
    datalayer_event = datalayer_attr.event;
    request_origin = datalayer_attr.origin;
    cart_total_value = datalayer_attr.cart_total_value;
    user_email = datalayer_attr.user_email;

    if (request_origin === 'payment') { // payment datalayer can have multiple items
      datalayer_items = datalayer_attr.items_object;
    } else { // if is not payment then is a single item for add to or remove from cart
      item_id = datalayer_attr.item_id;
      item_quantity = datalayer_attr.item_quantity;
      self.getDatalayerAttr();
      if (request_origin === 'examentraining') { // examentraining have 3 categories
        datalayer_items = [{
          item_id: item_id,
          item_name: item_name,
          item_brand: 'Examentraining',
          item_category: item_category,
          item_category2: item_category2,
          item_category3: item_category3,
          price: item_price,
          quantity: item_quantity
        }];
      } else { // Regular products have only the category4
        datalayer_items = [{
          item_id: item_id,
          item_name: item_name,
          item_brand: item_brand,
          item_category4: item_category4,
          price: item_price,
          quantity: item_quantity
        }];
      }
    }

    if (datalayer_event === 'purchase') {
      transaction_id = datalayer_attr.transaction_id;
      ecommerce = {
        currency: 'EUR', // Currency is required in 3-letter ISO 4217 format.
        items: datalayer_items,
        transaction_id: transaction_id,
        value: cart_total_value
      }
    } else if ((datalayer_event === 'add_to_cart') || (datalayer_event === 'remove_from_cart')) {
      ecommerce = {
        currency: 'EUR', // Currency is required in 3-letter ISO 4217 format.
        items: datalayer_items
      }
    } else {
      ecommerce = {
        currency: 'EUR', // Currency is required in 3-letter ISO 4217 format.
        items: datalayer_items,
        value: cart_total_value
      }
    }

    const datalayer = {
      event: datalayer_event,
      ecommerce: ecommerce,
      user: {}
    };


    // Set user id to localStorage key if set, else get it via ajax
    user_id = window.localStorage.getItem('user_id');
    if (!user_id) {
      // set user_email if user_email is set, else pick it up from the local storage
      user_email = user_email ?? window.localStorage.getItem('user_email_key');
      if (user_email) {
        $.ajax({
          url: ajax_link,
          method: 'post',
          async: false, // fix for put values in variables
          data: {
            action: 'lyceo_hash',
            nonce: ajax_nonce,
            string: user_email,
          },
        }).done(function (data) {
          user_id = data;
          window.localStorage.setItem('user_id', user_id);
        });
      }
    }

    if (datalayer_event === 'purchase' && user_email) {
      datalayer.user.user_hashed_email = user_email;
    }

    // Set user_id in the datalayer
    if (user_id) {
      datalayer.user.user_id = user_id;
    }

    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    window.dataLayer.push(datalayer);
  }

  // Define the other attributes based on the item_id
  getDatalayerAttr() {
    if (request_origin === 'examentraining') { // define the ajax action based on the type of product
      ajax_action = 'get_exam';
    } else {
      ajax_action = 'get_product';
    }

    // Ajax load the product attributes
    $.ajax({
      url: ajax_link,
      method: 'post',
      async: false, // fix for put values in variables
      data: {
        action: ajax_action,
        nonce: ajax_nonce,
        product_id: item_id,
      },
    }).done(function (data) {
      item_name = JSON.parse(data).item_name;
      item_price = JSON.parse(data).item_price;
      if (request_origin === 'examentraining') {
        item_category = JSON.parse(data).item_category;
        item_category2 = JSON.parse(data).item_category2.post_title;
        item_category2 = item_category2.replace(" -", "");
        item_category3 = JSON.parse(data).item_category3;
      } else {
        item_category4 = JSON.parse(data).item_category4;
        if (JSON.parse(data).item_brand != null) {
          item_brand = JSON.parse(data).item_brand;
        }
      }
    });
  }
}

